/**
 * Created by nguyendx 2017/09/16.
 */
import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { Router } from "@angular/router";
import { ApiEvsService } from "./ApiEvs.service";
import { environment } from "../../../environments/environment";

@Injectable()
export class EvsProductService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
    this.setEndPoint("/products");
  }

  // get all list
  getProductStasitic(data) {
    return this.get("/products/statistic", data);
  }
  getAllProduct(data: any) {
    return this.get("/products", data);
  }
  getProducts(data: any) {
    return this.get("/product/list", data);
  }

  getDetaiById(id) {
    return this.get("/products/" + id);
  }

  createNewProduct(data: any) {
    return this.post("/products", data);
  }

  updateProductById(id, data: any) {
    return this.put("/products/" + id, data);
  }
  updateStatusById(id, data: any) {
    return this.put("/products/" + id + "/change-status", data);
  }

  deleteProduct(id) {
    return this.delete("/products/" + id);
  }

  multiDelete(ids: any) {
    return this.multiPost("/products/bulk-delete", ids);
  }

  multiUpdateStatus(data: any) {
    return this.multiPost("/products/bulk-status", data);
  }

  //chuongnv:
  listProduct(data?: any) {
    return this.get("/products", data);
  }

  // find product info by barcode
  public findProduct(barcode) {
    return this.getFullUrl(environment.apiIcheck + "/scan/" + barcode);
  }

  public findProductContent(barcode) {
    return this.getFullUrl(
      environment.apiIcheck + "/products/" + barcode + "/informations"
    );
  }

  loadListVendor(data: any) {
    return this.get("/vendors", data);
  }
  loadVendorDetail(id: any) {
    return this.get("/vendors/" + id);
  }
  updateVendorDetail(id: any, data: any) {
    return this.put("/vendors/" + id, data);
  }

  public deleteAssignProduct(product_id, user_id) {
    return this.delete("/products/" + product_id + "/unassign/" + user_id);
  }
  public assignProduct(product_id, user_id) {
    return this.post("/products/" + product_id + "/assign/" + user_id);
  }

  public getAssignProduct(user_id, data_get?: any) {
    return this.get("/products/assign/" + user_id, data_get);
  }

  getListVariant(idProduct: any, option: any = null) {
    return this.get(`/product/${idProduct}/extras`, option);
  }

  getDetailVariantById(idProduct: any, idVariant: any) {
    return this.get(`/product/${idProduct}/extra/${idVariant}`);
  }

  addProductVariant(idProduct: any, body: any = null) {
    return this.post(`/product/${idProduct}/extras`, body);
  }

  updateProductVariant(idProduct: any, idExtra: any, body: any = null) {
    return this.put(`/product/${idProduct}/extra/${idExtra}`, body);
  }

  deleteProductVariant(idProduct: any, idExtra: any) {
    return this.delete(`/product/${idProduct}/extra/${idExtra}`);
  }



  getListECommerce() {
    return this.get(`/qr-core-aps/e_commerce`);
  }
  getListProduct(id: any, data: any) {
    return this.get(`/qr-core-aps/product_link/${id}`, data);
  }
  createdProduct(id: any, body: any = null) {
    return this.post(`/qr-core-aps/product_link/${id}`, body);
  }

  getProductStore( data: any) {
    return this.get(`/qr-core-aps/point_of_sales/`, data);
  }
  postProductStore(body: any) {
    return this.post(`/qr-core-aps/product_store`, body);
  }

  getProductWarrantyReminderConfig(id: any) {
    return this.get(`/qr-core-aps/product/${id}/warranty_reminder_config`);
  }
}



// WEBPACK FOOTER //
// /app/src/app/common/services/EvsProduct.service.ts